function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var U = Object.defineProperty;
var k = function k(i, e, t) {
  return e in i ? U(i, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : i[e] = t;
};
var h = function h(i, e, t) {
  return k(i, _typeof(e) != "symbol" ? e + "" : e, t), t;
};
var E = ["plt-nst-tms-we-01-apim.azure-api.net", "alpha.uipath.com", "staging.uipath.com", "cloud.uipath.com", "staging.gov.uipath-dev.com", "alpha.gov.uipath-dev.com", "govcloud.uipath.us"];
function f(i) {
  var e = window.location.host;
  return E.includes(e) ? "https://".concat(e, "/identity_") : "https://".concat(e, "/").concat(i ? "identity" : "identity_");
}
import a from "js-cookie";
import { v4 as I } from "uuid";
var u = "UiPathIdentitySessionId";
function g() {
  a.get(u) || a.set(u, I(), {
    path: "/",
    secure: !1
  });
}
function S() {
  a.remove(u, {
    path: "/",
    domain: window.location.hostname,
    secure: !1
  });
}
function y() {
  return a.get(u);
}
function L() {
  var i;
  return (i = window.User) == null ? void 0 : i.access_token;
}
function M() {
  var i;
  return (i = window.User) == null ? void 0 : i.id_token;
}
function $() {
  var _window$User;
  return (_window$User = window.User) !== null && _window$User !== void 0 ? _window$User : null;
}
function w() {
  return !!y();
}
var r = /*#__PURE__*/function () {
    function r() {
      _classCallCheck(this, r);
    }
    _createClass(r, [{
      key: "error",
      value: function error(e) {
        var _console;
        for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          t[_key - 1] = arguments[_key];
        }
        (_console = console).error.apply(_console, [e].concat(t));
      }
    }, {
      key: "info",
      value: function info(e) {
        var _console2;
        for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          t[_key2 - 1] = arguments[_key2];
        }
        (_console2 = console).log.apply(_console2, [e].concat(t));
      }
    }, {
      key: "debug",
      value: function debug(e) {
        var _console3;
        for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          t[_key3 - 1] = arguments[_key3];
        }
        (_console3 = console).log.apply(_console3, [e].concat(t));
      }
    }, {
      key: "warn",
      value: function warn(e) {
        var _console4;
        for (var _len4 = arguments.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          t[_key4 - 1] = arguments[_key4];
        }
        (_console4 = console).warn.apply(_console4, [e].concat(t));
      }
    }], [{
      key: "getInstance",
      value: function getInstance() {
        return r.instance || (r.instance = new r()), r.instance;
      }
    }]);
    return r;
  }(),
  o = r;
h(o, "instance");
function q(i) {
  if (!i) return !1;
  if (i === "/") return !0;
  var e = /^\/[a-zA-Z0-9_\-/]*(\?[\w%&\-=,]+)?$/,
    t = /^(http|https):\/\/[^ "]+$/;
  return e.test(i) ? !0 : !(!t.test(i) || new URL(i).hostname !== window.location.hostname);
}
var l = function (n) {
    return n.NoMatchingState = "No matching state found in storage", n.IFrameTimeout = "IFrame timed out without a response", n.InvalidGrant = "invalid_grant", n.LoginRequired = "login_required", n.FailedToFetch = "TypeError: Failed to fetch", n;
  }(l || {}),
  v = function v(i) {
    var e = "".concat(window.location.origin, "/portal_/autherror");
    if (i instanceof Error) {
      window.location.assign("".concat(e, "?error=").concat(i.message));
      return;
    }
    window.location.assign(e);
  };
import { UserManager as C, WebStorageStateStore as P } from "oidc-client-ts";
import { Log as p } from "oidc-client-ts";
function _() {
  return window.localStorage.getItem("AUTH_DEBUG") === "true";
}
function x() {
  p.setLogger(o.getInstance()), p.setLevel(p.DEBUG);
}
var c = /*#__PURE__*/function () {
  function c() {
    _classCallCheck(this, c);
    this.set(null);
  }
  _createClass(c, [{
    key: "set",
    value: function set(e) {
      window.User = e;
    }
  }, {
    key: "remove",
    value: function remove() {
      window.User = null;
    }
  }, {
    key: "get",
    value: function get() {
      return window.User;
    }
  }]);
  return c;
}();
var d = /*#__PURE__*/function () {
  function d() {
    _classCallCheck(this, d);
    _defineProperty(this, "_isSigningOut", !1);
  }
  _createClass(d, [{
    key: "isSigningOut",
    get: function get() {
      return this._isSigningOut;
    },
    set: function set(e) {
      this._isSigningOut = e;
    }
  }]);
  return d;
}();
var m = /*#__PURE__*/function (_C) {
  _inherits(m, _C);
  var _super = _createSuper(m);
  function m(e) {
    var _e$authority, _e$monitorSession, _e$onSigninError;
    var _this;
    _classCallCheck(this, m);
    (_this = _super.call(this, _objectSpread(_objectSpread({}, e), {}, {
      client_id: e.client_id.toLowerCase(),
      authority: (_e$authority = e.authority) !== null && _e$authority !== void 0 ? _e$authority : f(e.isMsi),
      monitorSession: (_e$monitorSession = e.monitorSession) !== null && _e$monitorSession !== void 0 ? _e$monitorSession : !0,
      stopCheckSessionOnError: !0,
      response_type: "code",
      userStore: new P({
        store: window.sessionStorage,
        prefix: e.storagePrefix
      })
    })), _defineProperty(_assertThisInitialized(_this), "_user", new c()), _defineProperty(_assertThisInitialized(_this), "_refreshPromise", null), _defineProperty(_assertThisInitialized(_this), "_signoutState", new d()), _defineProperty(_assertThisInitialized(_this), "_onSigninError", void 0)), _this._onSigninError = (_e$onSigninError = e.onSigninError) !== null && _e$onSigninError !== void 0 ? _e$onSigninError : v, _() && x(), _this.signinComplete = _this.signinComplete.bind(_assertThisInitialized(_this)), _this._handleSigninError = _this._handleSigninError.bind(_assertThisInitialized(_this)), _this._expireSession = _this._expireSession.bind(_assertThisInitialized(_this)), _this.registerCustomEvents();
    return _this;
  }
  _createClass(m, [{
    key: "registerCustomEvents",
    value: function registerCustomEvents() {
      this.events.addUserSignedOut(this._expireSession), this.events.addUserLoaded(g), this.events.addAccessTokenExpired(this.signinComplete);
    }
  }, {
    key: "unregisterCustomEvents",
    value: function unregisterCustomEvents() {
      this.events.removeUserSignedOut(this._expireSession), this.events.removeUserLoaded(g), this.events.removeAccessTokenExpired(this.signinComplete);
    }
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var e;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _get(_getPrototypeOf(m.prototype), "getUser", this).call(this);
            case 2:
              e = _context.sent;
              return _context.abrupt("return", (e && !this._user.get() && this._user.set(e), e));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getUser() {
        return _getUser.apply(this, arguments);
      }
      return getUser;
    }()
  }, {
    key: "storeUser",
    value: function () {
      var _storeUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _get(_getPrototypeOf(m.prototype), "storeUser", this).call(this, e);
            case 2:
              this._user.set(e);
              e && g();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function storeUser(_x) {
        return _storeUser.apply(this, arguments);
      }
      return storeUser;
    }()
  }, {
    key: "removeUser",
    value: function () {
      var _removeUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (S(), this._user.remove(), _get(_getPrototypeOf(m.prototype), "removeUser", this).call(this)));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function removeUser() {
        return _removeUser.apply(this, arguments);
      }
      return removeUser;
    }()
  }, {
    key: "signinRedirect",
    value: function () {
      var _signinRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
        var t;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              t = e == null ? void 0 : e.state;
              return _context4.abrupt("return", (t != null && t.returnTo || (this._logger.warn("no returnTo provided, using default"), t = {
                returnTo: location.pathname + location.search
              }), e != null && e.organizationName && (e.acr_values = "tenantName:".concat(e.organizationName), delete e.organizationName), _get(_getPrototypeOf(m.prototype), "signinRedirect", this).call(this, _objectSpread(_objectSpread({}, e), {}, {
                state: t
              }))));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function signinRedirect(_x2) {
        return _signinRedirect.apply(this, arguments);
      }
      return signinRedirect;
    }()
  }, {
    key: "signinCallback",
    value: function () {
      var _signinCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              return _context5.abrupt("return", _get(_getPrototypeOf(m.prototype), "signinCallback", this).call(this, e));
            case 4:
              _context5.prev = 4;
              _context5.t0 = _context5["catch"](0);
              _context5.next = 8;
              return this._handleSigninError(_context5.t0, {
                state: {
                  returnTo: "/"
                }
              });
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 4]]);
      }));
      function signinCallback(_x3) {
        return _signinCallback.apply(this, arguments);
      }
      return signinCallback;
    }()
  }, {
    key: "signoutRedirect",
    value: function () {
      var _signoutRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", (this._signoutState.isSigningOut = !0, _get(_getPrototypeOf(m.prototype), "signoutRedirect", this).call(this, e)));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function signoutRedirect(_x4) {
        return _signoutRedirect.apply(this, arguments);
      }
      return signoutRedirect;
    }()
  }, {
    key: "signoutRedirectCallback",
    value: function () {
      var _signoutRedirectCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", (this._signoutState.isSigningOut = !1, _get(_getPrototypeOf(m.prototype), "signoutRedirectCallback", this).call(this, e)));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function signoutRedirectCallback(_x5) {
        return _signoutRedirectCallback.apply(this, arguments);
      }
      return signoutRedirectCallback;
    }()
  }, {
    key: "signinComplete",
    value: function () {
      var _signinComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.clearStaleState();
            case 3:
              if (!this._signoutState.isSigningOut) {
                _context8.next = 5;
                break;
              }
              return _context8.abrupt("return");
            case 5:
              if (!w()) {
                _context8.next = 10;
                break;
              }
              _context8.next = 8;
              return this.signinSilent(e);
            case 8:
              _context8.next = 12;
              break;
            case 10:
              _context8.next = 12;
              return this.signinRedirect(e);
            case 12:
              _context8.next = 18;
              break;
            case 14:
              _context8.prev = 14;
              _context8.t0 = _context8["catch"](0);
              _context8.next = 18;
              return this._handleSigninError(_context8.t0, e);
            case 18:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 14]]);
      }));
      function signinComplete(_x6) {
        return _signinComplete.apply(this, arguments);
      }
      return signinComplete;
    }()
  }, {
    key: "_useRefreshToken",
    value: function () {
      var _useRefreshToken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!this._refreshPromise) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return", this._refreshPromise);
            case 2:
              this._refreshPromise = _get(_getPrototypeOf(m.prototype), "_useRefreshToken", this).call(this, e);
              _context9.prev = 3;
              _context9.next = 6;
              return this._refreshPromise;
            case 6:
              return _context9.abrupt("return", _context9.sent);
            case 7:
              _context9.prev = 7;
              this._refreshPromise = null;
              return _context9.finish(7);
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[3,, 7, 10]]);
      }));
      function _useRefreshToken(_x7) {
        return _useRefreshToken2.apply(this, arguments);
      }
      return _useRefreshToken;
    }()
  }, {
    key: "_handleSigninError",
    value: function () {
      var _handleSigninError2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e, t) {
        var s;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              s = "unknown";
              _context10.t0 = (e instanceof Error && (s = e.message), s);
              _context10.next = _context10.t0 === "No matching state found in storage" ? 4 : _context10.t0 === "IFrame timed out without a response" ? 4 : _context10.t0 === "invalid_grant" ? 4 : _context10.t0 === "login_required" ? 4 : _context10.t0 === "TypeError: Failed to fetch" ? 8 : 9;
              break;
            case 4:
              this._logger.warn("Well known error occurred: ".concat(s, " - retrying..."));
              _context10.next = 7;
              return this.signinRedirect(t);
            case 7:
              return _context10.abrupt("break", 10);
            case 8:
              return _context10.abrupt("break", 10);
            case 9:
              this._logger.error("Unknown error occurred: ".concat(e)), this._onSigninError(e);
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function _handleSigninError(_x8, _x9) {
        return _handleSigninError2.apply(this, arguments);
      }
      return _handleSigninError;
    }()
  }, {
    key: "_expireSession",
    value: function () {
      var _expireSession2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var e;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.getUser();
            case 2:
              e = _context11.sent;
              sessionStorage.clear();
              this.stopSilentRenew();
              _context11.next = 7;
              return this.signoutRedirect({
                id_token_hint: e == null ? void 0 : e.id_token
              });
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function _expireSession() {
        return _expireSession2.apply(this, arguments);
      }
      return _expireSession;
    }()
  }]);
  return m;
}(C);
export { o as AuthLogger, m as IdentityUserManager, l as WellKnownAuthErrors, L as getAccessToken, M as getIdToken, f as getIdentityAuthority, $ as getUser, w as hasValidSession, q as validateReturnUrl };